import Home from './components/Home';
import Contact from './components/Contact';
import About from './components/About';
import Painting from './components/Painting';
import Scaffolding from './components/Scaffolding';
import Welding from './components/Welding';

import TermsOfService from './components/Documents/TermsOfService';
import PrivacyPolicy from './components/Documents/PrivacyPolicy';
import Rodo from './components/Documents/Rodo';

import i18n from './i18n';

export default [
    {
        path: '/',
        redirect: `/${i18n.locale}`
    },
    {
        path: '/:lang',
        component: {
            render (c) { return c('router-view') }
        },
        children: [
            // MAIN HOME PAGE & CONTACT
            {
                path: '/',
                component: Home,
            },
            {
                path: 'contact',
                component: Contact,
            },
            {
                path: 'about',
                component: About,
            },
            {
                path: 'terms-of-service',
                component: TermsOfService,
            },
            {
                path: 'privacy-policy',
                component: PrivacyPolicy,
            },
            {
                path: 'rodo',
                component: Rodo,
            },
            {
                path: 'painting',
                component: Painting,
            },
            {
                path: 'scaffolding',
                component: Scaffolding,
            },
            {
                path: 'welding',
                component: Welding,
            },
        ]
    }

]